/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import root from 'window-or-global';
import { PersistentStorage } from './PersistentStorage';
import type { Storage } from './PersistentStorage';

export type SessionStorageKey =
  | 'AZ_SESSION_STATUS'
  | 'fromCheckout'
  | 'selectedFirstLevelItem'
  | 'level1Label'
  | 'configureTechVehicle'
  | 'pageNumber'
  | 'dateFilter'
  | 'orderTypeFilter'
  | 'pdpUtagViewAffinity'
  | 'pdpUtagLinkAffinity'
  | 'popularSearchClicked'
  | 'fromSignin'
  | 'signInAlertShown'
  | 'signInAlertDisabled'
  | 'signInPopupShown'
  | 'signInPopupDisabled'
  | 'isNewAccount'
  | 'addOrUpdateCart'
  | 'skuId'
  | 'skuIdSetStore'
  | 'sister_store_update_type'
  | 'tcPilotPrompt'
  | 'quantity'
  | 'storeNumber'
  | 'productId'
  | 'productFindingMethod'
  | 'prefilledEmail'
  | 'contactInformationEdit'
  | 'citrusImpressions'
  | 'citrusClicks'
  | 'oemBrandName'
  | 'oemPartNumber'
  | 'searchMethod'
  | 'visualCategoryRank'
  | 'typeAheadValue'
  | 'resetPasswordFrom'
  | 'performedSearch'
  | 'savedForLaterItem'
  | 'lwTestExperience'
  | 'sflNotification'
  | 'productRank'
  | 'returnToSearchResults'
  | 'signInModalOpened'
  | 'DropDownRendered'
  | 'previousPreferredVehicleId'
  | 'previousStore'
  | 'xFusionQueryId'
  | 'filterSelectionAnalytics'
  | 'originalExternalReferrer'
  | 'paypalDeviceData'
  | 'showOrderHistoryReviewCandidates'
  | 'showHomeReviewCandidates'
  | 'showAccountReviewCandidates'
  | 'showHomeBuyAgainCandidates'
  | 'showAccountBuyAgainCandidates'
  | 'showPLPBuyAgainCandidates'
  | 'showPDPBuyAgainCandidates'
  | 'addressPopulatedFromPaypalExpress'
  | 'googleRetailAttributionToken'
  | 'googleRetailRecommendationAttributionToken'
  | 'quickFilters'
  | 'oneClickFilters'
  | 'categorypagetype'
  | 'showDealAddedToast'
  | 'productType'
  | 'pbs-search-engine'
  | 'search-stage-name'
  | 'search-query-time'
  | 'hideRewardsModal'
  | 'enhancedPDPContent'
  | 'searchButtonPressed'
  | 'pdpAffinityContext'
  | 'userPageViewAnalyticsCalled'
  | 'signifydSessionId'
  | 'loqateOperationCounts'
  | 'openStoreModalFromCheckout'
  | 'locationModalShown'
  | 'locationModalClosed'
  | 'expandResultsAnalytics'
  | 'vehicleUpdateFromFitmentBadge';
/**
 * Session storage wrapper with type safety
 * @example
 * sessionStorage.setItem('signInModalOpened', 'true');
 * const isModalOpened = sessionStorage.getItem('signInModalOpened');
 */

export const sessionStorage: Readonly<Storage<SessionStorageKey>> =
  new PersistentStorage<SessionStorageKey>(root.sessionStorage);
